import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { recolecciondom } from '../../servicios/recoleccion-dom.service'; // Ajusta la ruta a tu servicio
import { user } from '../../entidades/gwuser'; // Ajusta ruta
import jwt_decode from "jwt-decode";
import { BreakpointObserver } from '@angular/cdk/layout';

@Component({
  selector: 'app-guias-web-checkout',
  templateUrl: './guias-web-checkout.component.html',
  styleUrls: ['./guias-web-checkout.component.css']
})
export class GuiasWebCheckoutComponent implements OnInit {

 // Datos Usuario
  userGw: user;
  isLoguedin: boolean = false;
  datagw: any;
  token: string;
  tokendatos: any;
  idcliente: number=-1;

  // Datos Paquetes
  allPackages: any[] = []; // Todos los que vienen del endpoint
  filteredPackages: any[] = []; // Los que se muestran en el grid actual
  selectedPackage: any = null; // El paquete seleccionado (Simple)
  selectedPackageDetail: any = null; // El detalle completo con beneficios (Endpoint 2)

  // UI States
  loading: boolean = true;
  loadingDetail: boolean = false;
  activeTab: string = '1 Kg.'; // Tab por defecto

  // Mapeo de Tabs (Para agrupar los pesos pesados)
  tabs = [
    { id: '1 Kg.', label: '📦 1 Kg.' },
    { id: '5 Kg.', label: '📦 5 Kg.' },
    { id: 'heavy', label: '🚛 Carga Pesada (+10kg)' }
  ];

  constructor(
    private recolecciondom: recolecciondom,
    private router: Router,
    private route: ActivatedRoute,
    private breakpointObserver: BreakpointObserver
  ) { }

  ngOnInit(): void {
    this.checkSession();
    this.loadPackages();

    this.breakpointObserver
      .observe(['(max-width: 719px)'])
      .subscribe(result => {
        this.tabs = this.tabs.map(tab =>
          tab.id === 'heavy'
            ? {
              ...tab,
              label: result.matches ? '🚛 +10kg' : '🚛 Carga Pesada (+10kg)'
            }
            : tab
        );
      });
  }

checkSession() {
  const token = sessionStorage.getItem("token") || localStorage.getItem("token");
  if (token) {
    this.isLoguedin = true;
    // si guardas datosUser en localStorage deja eso, si no, usa decode:
    const datos = localStorage.getItem("datosUser");
    this.userGw = datos ? JSON.parse(datos) : (jwt_decode(token) as any);
  } else {
    this.isLoguedin = false;
  }
}

loadPackages() {
  this.loading = true;

  // 1) Resolver idcliente (tu lógica actual)
  if (sessionStorage.getItem("token")) {
    this.token = sessionStorage.getItem("token") as string;
    this.tokendatos = jwt_decode(this.token);
    this.userGw = this.tokendatos;
    this.idcliente = this.userGw.idUser;
  } else {
    this.idcliente = -1;
  }

  // 2) Traer paquetes
  this.recolecciondom.getPaquetesGuias(this.idcliente).then((data) => {
    this.allPackages = data || [];

    // 3) Leer query params y preseleccionar
    this.route.queryParams.subscribe(params => {
      const preId = params['id'];
      const sku = params['sku'];

      // A) Legacy: viene id por URL
      if (preId) {
        const found = this.allPackages.find(p => String(p.id) === String(preId));
        if (found) {
          this.setTabFromPackage(found.descripcion1);
          this.selectPackage(found);
          this.loading = false;
          return;
        }
      }

      // B) Nuevo: viene sku por URL (ej: 5kg-50)
      if (sku) {
        const parsed = this.parseSku(String(sku));
        if (parsed) {
          this.setTabFromPackage(parsed.weightDesc);
          const foundBySku = this.findPackageBySku(parsed);
          if (foundBySku) {
            this.selectPackage(foundBySku);
            this.loading = false;
            return;
          }
        }
      }

      // C) SIN tocar Login: fallback a sessionStorage (cuando login no re-envía params)
      const returnSku = sessionStorage.getItem('gw_return_sku');
      const returnId = sessionStorage.getItem('gw_return_id');

      // Solo aplica si NO vino nada por URL
      if (!sku && !preId && (returnSku || returnId)) {

        // 1) Preferimos sku si existe
        if (returnSku) {
          const parsed = this.parseSku(returnSku);
          if (parsed) {
            this.setTabFromPackage(parsed.weightDesc);
            const found = this.findPackageBySku(parsed);
            if (found) {
              this.selectPackage(found);
              this.loading = false;

              // limpiar contexto de retorno
              sessionStorage.removeItem('gw_return_sku');
              sessionStorage.removeItem('gw_return_id');
              sessionStorage.removeItem('gw_return_to');

              return;
            }
          }
        }

        // 2) Si sku no resolvió, intentamos por id
        if (returnId) {
          const found = this.allPackages.find(p => String(p.id) === String(returnId));
          if (found) {
            this.setTabFromPackage(found.descripcion1);
            this.selectPackage(found);
            this.loading = false;

            sessionStorage.removeItem('gw_return_sku');
            sessionStorage.removeItem('gw_return_id');
            sessionStorage.removeItem('gw_return_to');

            return;
          }
        }

        // Si no encontró nada, limpiamos para no intentar siempre
        sessionStorage.removeItem('gw_return_sku');
        sessionStorage.removeItem('gw_return_id');
        sessionStorage.removeItem('gw_return_to');
      }

      // D) Default
      this.filterByTab('1 Kg.');
      this.loading = false;
    });

  }).catch((err) => {
    console.error("Error cargando paquetes", err);
    this.loading = false;
  });
}
Record

  // Lógica de Filtrado Inteligente
  filterByTab(tabId: string) {
    this.activeTab = tabId;
    
if (tabId === 'heavy') {
  this.filteredPackages = this.allPackages.filter(p => {
    const n = parseInt(String(p.descripcion1), 10);
    return !isNaN(n) && n >= 10;
  });
} else {
  this.filteredPackages = this.allPackages.filter(p => p.descripcion1 === tabId);
}
  }

  // Detectar tab automáticamente al venir de fuera
  setTabFromPackage(desc1: string) {
    if (['10 Kg.', '20 Kg.', '30 Kg.'].includes(desc1)) {
      this.activeTab = 'heavy';
    } else {
      this.activeTab = desc1; // '1 Kg.' o '5 Kg.'
    }
    this.filterByTab(this.activeTab);
  }

  // Al hacer clic en una tarjeta
  selectPackage(pkg: any) {
    this.selectedPackage = pkg;
    this.loadingDetail = true;
    
    // Scroll suave al resumen en móviles
    if(window.innerWidth < 900) {
      setTimeout(() => {
        document.getElementById('checkout-summary')?.scrollIntoView({behavior: 'smooth'});
      }, 100);
    }

      if(sessionStorage.getItem("token")){
        this.token = sessionStorage.getItem("token");
        this.tokendatos = jwt_decode(this.token);
        this.userGw = this.tokendatos;
        this.idcliente = this.userGw.idUser;
        }
        else{
          this.idcliente=-1;
        }
      this.recolecciondom.getDetallePaquetesGuias(pkg.id,this.idcliente).then((data) => {
        this.selectedPackageDetail = data; // Aquí viene 'beneficios', 'detalle', etc.
        this.loadingDetail = false;
      });


    // Llamada al segundo endpoint para traer beneficios (CargarguiasPaquetesDescripcion)
    // this.recolecciondom.obtenerPaquetesDescripcion(pkg.id).subscribe(
    //   (detail: any) => {
    //     this.selectedPackageDetail = detail; // Aquí viene 'beneficios', 'detalle', etc.
    //     this.loadingDetail = false;
    //   },
    //   (err) => {
    //     console.error("Error cargando detalle", err);
    //     this.loadingDetail = false;
    //   }
    // );
  }

private buildSkuFromSelected(): string | null {
  if (!this.selectedPackage) return null;

  // selectedPackage.descripcion1 viene como "5 Kg." / "10 Kg." etc
  const kg = parseInt(String(this.selectedPackage.descripcion1), 10);
  const qty = Number(this.selectedPackage.numGuias);

  if (isNaN(kg) || !qty) return null;

  return `${kg}kg-${qty}`;
}

comprar() {
  const sku = this.buildSkuFromSelected();
  const idSel = this.selectedPackage?.id;

  if (!this.isLoguedin) {
    // ✅ Guardar contexto para recuperar selección al volver del login (sin tocar login)
    if (sku) {
      sessionStorage.setItem('gw_return_sku', sku);
    } else {
      sessionStorage.removeItem('gw_return_sku');
    }

    if (idSel != null) {
      sessionStorage.setItem('gw_return_id', String(idSel));
    } else {
      sessionStorage.removeItem('gw_return_id');
    }

    // opcional: marcador de retorno (por si lo quieres usar después)
    sessionStorage.setItem('gw_return_to', 'guias-web');

    // ✅ Navegar al login SIN depender de que el login reenvíe sku/id
    this.router.navigate(
      ["/herramientasDigitales/login"],
      { queryParams: { to: 'guias-web' } }
    );
    return;
  }

  // Si ya está logueado, continúa al pago normal
  if (this.selectedPackageDetail) {
    const payload = btoa(JSON.stringify(this.selectedPackageDetail));
    this.router.navigate(["/detalle-transaccion"], { queryParams: { rf: payload } });
  }
}

  // Helper para formato de moneda
  formatMoney(amount: any) {
    return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(Number(amount));
  }

  private parseSku(sku: string): { weightDesc: string; qty: number } | null {
  // Formatos esperados: "1kg-10", "5kg-25", "10kg-10", etc.
  const m = (sku || '').toLowerCase().match(/^(\d+)\s*kg-(\d+)$/);
  if (!m) return null;

  const kg = Number(m[1]);
  const qty = Number(m[2]);

  // Tu backend usa "1 Kg.", "5 Kg.", "10 Kg."...
  const weightDesc = `${kg} Kg.`;

  return { weightDesc, qty };
}

private findPackageBySku(parsed: { weightDesc: string; qty: number }) {
  return this.allPackages.find(p =>
    String(p.descripcion1).trim() === parsed.weightDesc &&
    Number(p.numGuias) === parsed.qty
  );
}
}